import React from 'react'
import styled from 'styled-components'
import BusinessTravellerFooter from './businesstraveller/BusinessTravellerFooter'
import Pane from 'components/Common/Pane'

const Container = styled.footer`
  @media print {
    a[href]:after {
      content: "";
    }
  }
`

function Footer() {
  return (
    <Container className="PageFooter" data-testid="footer">
      <Pane background="neutral-six">
        <BusinessTravellerFooter />
      </Pane>
    </Container>
  )
}

export default Footer
